import React, { useEffect, useState } from 'react';
const LiveActivityIndicator = () => {
  const [visitorCount, setVisitorCount] = useState(87);
  const [recentPurchases, setRecentPurchases] = useState([{
    name: 'Sarah M.',
    time: '2 minutes ago',
    location: 'Phoenix, AZ'
  }, {
    name: 'John D.',
    time: '7 minutes ago',
    location: 'Boston, MA'
  }, {
    name: 'Linda K.',
    time: '12 minutes ago',
    location: 'Dallas, TX'
  }]);
  const [showNotification, setShowNotification] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(recentPurchases[0]);
  useEffect(() => {
    // Randomly fluctuate visitor count
    const visitorInterval = setInterval(() => {
      setVisitorCount(prev => prev + Math.floor(Math.random() * 3) - 1);
    }, 5000);
    // Show purchase notifications periodically
    let index = 0;
    const notificationInterval = setInterval(() => {
      setCurrentPurchase(recentPurchases[index]);
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 4000);
      index = (index + 1) % recentPurchases.length;
    }, 15000);
    return () => {
      clearInterval(visitorInterval);
      clearInterval(notificationInterval);
    };
  }, []);
  return <>
      <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6 shadow-sm" data-id="element-98">
        <div className="flex items-center justify-between mb-2" data-id="element-99">
          <div className="flex items-center" data-id="element-100">
            <div className="w-3 h-3 bg-green-500 rounded-full mr-2 relative" data-id="element-101">
              <span className="absolute top-0 left-0 w-3 h-3 bg-green-500 rounded-full animate-ping opacity-75" data-id="element-102"></span>
            </div>
            <p className="text-gray-700 font-medium" data-id="element-103">Live Activity</p>
          </div>
          <span className="text-sm text-gray-500" data-id="element-104">Updated just now</span>
        </div>
        <p className="text-gray-700" data-id="element-105">
          <span className="font-bold text-green-600" data-id="element-106">{visitorCount}</span>{' '}
          people are currently viewing this page
        </p>
        <div className="mt-2 text-sm text-gray-600" data-id="element-107">
          <span className="font-medium" data-id="element-108">Limited stock available</span> - Order
          while supplies last
        </div>
      </div>
      {showNotification && <div className="fixed bottom-20 left-4 bg-white p-3 rounded-lg shadow-lg border border-green-200 max-w-xs animate-slide-in z-50" data-id="element-109">
          <div className="flex items-start" data-id="element-110">
            <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-111">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-112">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-113" />
              </svg>
            </div>
            <div data-id="element-114">
              <p className="font-medium text-gray-800" data-id="element-115">
                {currentPurchase.name} from {currentPurchase.location}
              </p>
              <p className="text-sm text-gray-600" data-id="element-116">
                Purchased MyoQuell {currentPurchase.time}
              </p>
            </div>
          </div>
        </div>}
    </>;
};
export default LiveActivityIndicator;